<template>
  <div class="row">
    <div class="col mb-[16px]">
      <div class="flex justify-between items-center">
        <h4 class="font-weight-bold">Purchase Order Details</h4>
        <button class="bg-[#2463EB] p-[10px] rounded-[8px] text-white text-[14px] leading-[20px] font-medium"
          type="button" @click="addItem">
          <i class="mdi mdi-plus text-white"></i>
          Add Item
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table text-nowrap w-full min-h-[150px]">
        <thead class="bg-[#ECF9FF]">
          <tr>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Item #
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Description
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Quantity
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Total
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr v-for="(item, index) in items" :key="index">
            <td class="text-[14px] font-medium leading-[16.94px] text-[#353535]">
              {{ index + 1 }}
            </td>
            <td class="text-[14px] font-medium leading-[16.94px] text-[#353535]">
              {{ item.description }}
            </td>
            <td class="text-[14px] font-medium leading-[16.94px] text-[#353535]">
              {{ item.quantity }}
            </td>
            <td class="text-[14px] font-medium leading-[16.94px] text-[#353535]">
              <span v-if="item.price && item.price > 0">₦{{ formatMoney(getItemTotal(item)) }}</span>
            </td>
            <td>
              <span class="text-[#DC2828] text-[14px] font-normal leading-[20px] cursor-pointer"
                @click.prevent="removeItem(item.id)">
                Delete
              </span>
            </td>
          </tr>
          <tr v-if="items.length > 0">
            <td></td>
            <td></td>
            <td>Total Payable</td>
            <td>₦ {{ formatMoney(totalAmount) }}</td>
            <td></td>
          </tr>
          <tr v-if="!items.length > 0">
            <td colspan="5">
              <div class="text-center py-[100px]">
                <h4 class="text-[14px] text-[#353535] leading-[20px] font-normal">
                  No items in order
                </h4>
                <p class="text-[#96A0B5] text-[14px] leading-[20px] font-normal my-[8px]">
                  Click Add item button to add items to order
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="flex justify-end w-full mt-[16px]" v-if="!needsQuote && items.length > 0">
        <div class="max-w-[500px] w-full flex items-center justify-end gap-[10px]">
          <button
            class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none max-w-max w-full disabled:cursor-not-allowed"
            @click="close" :disabled="isBusy || isBusyModal">
            Cancel
          </button>
          <button :disabled="isBusy || isBusyModal" type="button" @click="onProceed('draft')"
            class="border-[1px] bg-[#7367f0] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none max-w-max w-full disabled:cursor-not-allowed">
            <span v-if="isBusy">Loading...</span>
            <span v-else>Save to draft</span>
          </button>
          <button :disabled="isBusy || isBusyModal" type="button" @click="onProceed('submitted')"
            class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none max-w-max w-full disabled:cursor-not-allowed">
            <span v-if="isBusyModal">Loading...</span>
            <span v-else>Generate Purchase Order</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { helper } from "@/helper";

export default {
  name: "PurchaseOrderDetail",
  props: ["items", "onProceed", "close", "isBusy", "isBusyModal", "needsQuote"],
  computed: {
    user: function () {
      return this.$store.state.currentUser;
    },
    subTotal() {
      return this.items.reduce((sum, item) => sum + this.getItemTotal(item), 0);
    },
    totalAmount() {
      const roundedTotal = Math.round(this.subTotal * 100) / 100;
      return this.formatMoney(roundedTotal);
    }
  },
  methods: {
    getItemTotal(item) {
      if (!item || !item.quantity || !item.price) {
        return 0;
      }
      return Math.round(Number(item.price) * Number(item.quantity) * 100) / 100;
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    addItem() {
      // eslint-disable-next-line no-undef
      $("#mod-item-add").modal("show");
    },
    removeItem(id) {
      this.$emit("onDeleteItem", id);
    },
  },
};
</script>